module.exports = __webpack_public_path__ + "img/photo-alarm2.5773e895.png";